// Copyright (c) Proto Labs, Inc. All Rights Reserved.
export class TokenManagerState {
    constructor(clientId, logger, storage) {
        this.state = {};
        this.storageKey = `token-manager:${clientId}`;
        this.logger = logger;
        this.storage = storage;
        const text = this.storage.getItem(this.storageKey);
        if (text) {
            this.logger.debug('TokenManagerState.constructor: using state from storage.');
            this.state = JSON.parse(text);
        }
    }
    get signinAttempt() {
        return this.state.signin_attempt || 0;
    }
    set signinAttempt(value) {
        this.state.signin_attempt = value;
    }
    get signinRedirect() {
        return this.state.signin_redirect || '/';
    }
    set signinRedirect(value) {
        this.state.signin_redirect = value;
    }
    get timeoutAt() {
        return this.state.timeout_at || undefined;
    }
    set timeoutAt(value) {
        this.state.timeout_at = value;
    }
    save() {
        this.logger.debug('TokenManagerState.save: setting state in storage.');
        this.storage.setItem(this.storageKey, JSON.stringify(this.state));
    }
    clear() {
        this.state = {};
        this.storage.removeItem(this.storageKey);
    }
}
//# sourceMappingURL=TokenManagerState.js.map